export default __webpack_public_path__ + "static/media/globe_black.08f5215f.png";